import { render, staticRenderFns } from "./StockAdjustmentTable.vue?vue&type=template&id=3764bcc2&scoped=true"
import script from "./StockAdjustmentTable.vue?vue&type=script&lang=ts"
export * from "./StockAdjustmentTable.vue?vue&type=script&lang=ts"
import style0 from "./StockAdjustmentTable.vue?vue&type=style&index=0&id=3764bcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764bcc2",
  null
  
)

export default component.exports